// @flow

import React, { Component } from 'react';

import { getGravatarUrl } from '@zapier/common-utils';

import type { Node } from 'react';

import type { ProfileObject } from 'web-ssr/rest/fragments/profiles';

const initialContextState = {
  refetch: () => {},
  data: {},
  loading: true,
  error: undefined,
  isLoggedIn: false,
  hasTeamAccount: false,
  primaryAccountId: undefined,
  currentProfileId: undefined,
  currentProfile: undefined,
  email: undefined,
  isDeveloper: false,
  isStaff: false,
  userAvatarUrl: undefined,
  userName: undefined,
};

export const HeaderContext = React.createContext(initialContextState);

type Props = {
  children: Node,
  refetch: () => void,
  data: any,
  loading: boolean,
  error: any,
};

type State = {
  // Apollo context
  data: {
    accounts?: any,
    profile?: any,
  },
  loading: boolean,
  error: ?Error,
  refetch: () => void,

  // Selector state
  isLoggedIn: boolean,
  hasTeamAccount: boolean,
  primaryAccountId?: string,
  currentProfileId?: string,
  currentProfile?: ProfileObject,
  email?: string,
  isDeveloper?: boolean,
  isStaff?: boolean,
  userAvatarUrl?: string,
  userName?: string,
};

class HeaderProvider extends Component<Props, State> {
  state = initialContextState;

  static getDerivedStateFromProps(props: Props) {
    const data = props.data || {};
    const { profiles, accounts } = data;

    const currentProfileId = profiles && profiles.active_id;
    const currentProfile =
      profiles && profiles.objects.find(({ id }) => id === currentProfileId);

    return {
      // Apollo context
      refetch: props.refetch,
      data,
      loading: props.loading,
      error: props.error,

      // Selector context
      isLoggedIn: profiles && Boolean(profiles.active_id),
      hasTeamAccount:
        accounts &&
        accounts.objects &&
        accounts.objects.find(
          account =>
            account && account.is_team_account && !account.team_account_end_date
        ),
      primaryAccountId: accounts && accounts.primary_id,
      currentProfileId,
      currentProfile,
      email: currentProfile && currentProfile.email,
      isDeveloper: currentProfile && currentProfile.is_developer,
      isStaff: currentProfile && currentProfile.is_staff,
      userAvatarUrl:
        currentProfile && getGravatarUrl(currentProfile.email_hash),
      userName: currentProfile && currentProfile.username,
    };
  }

  render() {
    return (
      <HeaderContext.Provider value={this.state}>
        {this.props.children}
      </HeaderContext.Provider>
    );
  }
}

export default HeaderProvider;
